import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=918f4a0c"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"
import style0 from "./Item.vue?vue&type=style&index=0&id=918f4a0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports